// Imports
import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'
import { createQuery } from '../../utils/filterUtils'

const getByPageId = async (pageId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/spyder/brands`,
    {
      params: { adLibraryIds: [pageId] },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data.data[0]
}

const getBrandMonthlyTraffic = async (pageId, mode, params) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/spyder/brands/monthly-traffic`,
    {
      params: {
        adLibraryId: pageId,
        mode,
        ...params
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data.data
}

const getBrandCreativeVelocity = async (pageId, params) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { startDate, endDate } = params

  const { data } = await AxiosConfig.get(
    `/spyder/velocity`,
    {
      params: { 
        adLibraryId: pageId,
        startDate,
        endDate
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data.data
}

const getBrandPartners = async (pageId, params = {}) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { limit = 100, offset = 0 } = params

  const { data } = await AxiosConfig.get(
    `/spyder/brands/partners`,
    {
      params: { 
        pageId, 
        limit, 
        offset 
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data.data
}

const findSimilarBrands = async (pageId, options = {}) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    `/chat-search/api/brands/similar`,
    {
      page_ids: [pageId],
      fb_pages_only: true,
      size: options.size ?? 10,
      ...options
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data.data
}

const getDiscoveryBrands = async (nextId, filters) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const params = {
    // Create the filters
    ...createQuery(filters),
    next: nextId
  }

  const { data } = await AxiosConfig.get(
    '/brands/discovery',
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getBrandAnalytics = async (pageId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/brands/analytics-beta/${pageId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getBrandBulkAnalytics = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/brands/analytics-beta/bulk',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getCreativeTests = async (nextId, brandId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const params = {
    next: nextId
  }

  const { data } = await AxiosConfig.get(
    `/brands/creative-tests/${brandId}`,
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getPinnedCreativeTests = async (dates, brandId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    dates: dates
  }

  const { data } = await AxiosConfig.post(
     `/brands/pinned-creative-tests/${brandId}`,
     payload,
     {
       headers: {
         Authorization: `Bearer ${token}`
       }
     }
  )

  return data
}

const getBrandRankingsScatterData = async (pageId, date, compareDaysAgo) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/brands/rankings/${pageId}/top-overview`,
    {
      params: { date, compareDaysAgo },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getBrandRankedAds = async (pageId, category, pagination) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/brands/rankings/${pageId}/list`,
    {
      params: {
        category,
        limit: pagination.limit,
        offset: pagination.page * pagination.limit
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createSpyderBrand = async (pageId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
	'/brands/spyder',
	{
	  pageId
	},
	{
	  headers: {
		Authorization: `Bearer ${token}`
	  }
	}
  )

  return data
}

export default {
  getByPageId,
  getBrandMonthlyTraffic,
  getBrandCreativeVelocity,
  getBrandPartners,
  findSimilarBrands,
  getBrandBulkAnalytics,
  getCreativeTests,
  getDiscoveryBrands,
  getBrandAnalytics,
  getPinnedCreativeTests,
  getBrandRankingsScatterData,
  getBrandRankedAds,
  createSpyderBrand
}
